import React, { useState, useEffect } from "react";
import { HydroDataContext } from "./context";

import { getHydroData } from "../services/services";

const HydroProvider = ({ children }) => {
  const [hydroData, setHydroData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchHydro = async () => {
      const hydro = await getHydroData({ lang: "el" })
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });
      setHydroData(hydro);
    };

    fetchHydro();
  }, []);

  return (
    <HydroDataContext.Provider
      value={{ hydroData, setHydroData, loading, error }}
    >
      {children}
    </HydroDataContext.Provider>
  );
};

export default HydroProvider;
